export default __webpack_public_path__ + "assets/ico_related-a3f79795.svg";